import type { IconNode } from '../types';

/**
 * @name reel-thread
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiA2IDQuNCA0LjZBMS41IDEuNSAwIDAgMSA1LjUgMmgxM2ExLjUgMS41IDAgMCAxIDEuMSAyLjVMMTggNiIgLz4KICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHg9IjYiIHk9IjYiIC8+CiAgPHBhdGggZD0ibTYgMTEgMTAtNSIgLz4KICA8cGF0aCBkPSJNMjIgMTZ2LTNhNCA0IDAgMCAwLTQtNEw2IDE1IiAvPgogIDxwYXRoIGQ9Im04IDE4IDEwLTUiIC8+CiAgPHBhdGggZD0ibTE4IDE4IDEuNiAxLjRhMS40NSAxLjQ1IDAgMCAxLTEuMSAyLjVoLTEzYTEuNSAxLjUgMCAwIDEtMS4xLTIuNUw2IDE4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/reel-thread
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const reelThread: IconNode = [
  ['path', { d: 'M6 6 4.4 4.6A1.5 1.5 0 0 1 5.5 2h13a1.5 1.5 0 0 1 1.1 2.5L18 6', key: 'ad6ouv' }],
  ['rect', { width: '12', height: '12', x: '6', y: '6', key: '1aa27j' }],
  ['path', { d: 'm6 11 10-5', key: '1gsd7q' }],
  ['path', { d: 'M22 16v-3a4 4 0 0 0-4-4L6 15', key: '1syuiw' }],
  ['path', { d: 'm8 18 10-5', key: '2s28in' }],
  [
    'path',
    { d: 'm18 18 1.6 1.4a1.45 1.45 0 0 1-1.1 2.5h-13a1.5 1.5 0 0 1-1.1-2.5L6 18', key: '10pw92' },
  ],
];

export default reelThread;
